import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import "./storyboard-cards.css";
import type { StoryboardCardsProps } from "./StoryboardCard";
import { registerStoryboardEditor } from "./storyboard-editor-actions";
const StoryboardCards = lazy(() => import("./StoryboardCard").then(module => ({ default: module.StoryboardCards })));
export function mountStoryboardCards(
  slot: HTMLElement,
  props: StoryboardCardsProps,
) {
  registerStoryboardEditor(String(props.project.id), (sceneId, button) => props.action(sceneId, "edit", button));
  setStudioView("storyboard-cards", `storyboard-cards:${props.project.id}`, <StoryboardCards {...props} />);
}
